import axios from "axios";

// create a single instance of axios to use for the whole app
const instance = axios.create({
    withCredentials: true,
    baseURL:process.env.VUE_APP_API_URL
});

// Add a request interceptor
instance.interceptors.request.use(function (config) {
    // Do something before request is sent
    config.headers["Accept"] = "application/json";
    config.headers["Authorization"] = `Bearer ${localStorage.getItem(
        "token"
    )}`;

    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});


instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // redirects to login page if token is removed or expired
        if (error.response?.status === 401 && window.location.pathname !== "/login") {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            location.href = "/login";
        }

        return Promise.reject(error);
    }
);

export default instance;
